import * as types from '@store/types'

const state = {
  isFetchingCampaigns: false,
  open: {
    profile: false,
    notifications: false
  }
}

const getters = {
  [types.LAYOUT_PROFILE]: ({ open }) => open.profile,
  [types.LAYOUT_NOTIFICATIONS]: ({ open }) => open.notifications,
  [types.LAYOUT_IS_OPENED]: ({ open }) => {
    const isOpened = Object.values(open).some(it => it)
    return isOpened
  },
  [types.IS_FETCHING_CAMPAIGNS]: ({ isFetchingCampaigns }) => isFetchingCampaigns
}

const mutations = {
  [types.LAYOUT_PROFILE]: (state) => {
    state.open.profile = !state.open.profile
  },
  [types.IS_FETCHING_CAMPAIGNS]: (state, payload) => {
    state.isFetchingCampaigns = payload
  },
  [types.LAYOUT_NOTIFICATIONS]: (state) => {
    state.open.notifications = !state.open.notifications
  },
  [types.LAYOUT_PROFILE_CLOSE]: (state) => {
    state.open.profile = false
  },
  [types.LAYOUT_NOTIFICATIONS_CLOSE]: (state) => {
    state.open.notifications = false
  }
}

const actions = {
  [types.LAYOUT_PROFILE]: ({ commit }) => commit(types.LAYOUT_PROFILE),

  [types.LAYOUT_NOTIFICATIONS]: ({ commit }) => commit(types.LAYOUT_NOTIFICATIONS),

  [types.LAYOUT_CLOSE]: ({ commit }) => {
    commit(types.LAYOUT_PROFILE_CLOSE)
    commit(types.LAYOUT_NOTIFICATIONS_CLOSE)
  }
}

export default { state, getters, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/layout.js